var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_vm._v("\n  Job COMPLETED\n  "),_c('job-object',{attrs:{"job-number":_vm.activity.job_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }